<template>
  <Main>
    <h1 class="mb-3">Page Not Found</h1>
    <p>Sorry the page you requested could not be found.</p>
  </Main>
</template>

<script>
import Main from "@/views/Main.vue";
import router from "@/router";

export default {
  name: "NotFound",
  components: {
    Main
  },
  extends: Main,
  data() {
    return {};
  },
  computed: {},
  methods: {}
};
</script>
<style lang="scss">
@import "@/assets/styles/common/_variables.scss";
</style>



// WEBPACK FOOTER //
// src/views/NotFound.vue